import { z } from "zod";
export function tool(input) {
    return input;
}
tool.schema = z;
